<template>
  <div class="container-fluid">
    <div class="vld-parent row pb-4 pr-0" :class="deploymentBgClass" :id="$id('calendar')" ref='calendarContainer'>

      <call-for-booking
        ref="callForBooking"
        :location="location"
        :brand="brand"/>

      <make-booking
        ref="makeBooking"
        :location="location"
        :initial-cart="initialCart"
        :saleFrom="saleFrom"
        :locationDiscount="locationDiscount"
        :brand="brand"
        :location-child-pricing="locationChildPricing"
        :adult-pricing-not-player-pricing="adultPricingNotPlayerPricing"
        :customer-request-marketing-permission="customerRequestMarketingPermission"
        :payment-provider="paymentProvider"
        :booking-label-adults="bookingLabelAdults"
        :booking-label-adults-selection="bookingLabelAdultsSelection"
        :booking-child-caveat="bookingChildCaveat"
        :pricing-style="pricingStyle"

        @refetch="refetchRoomSlots"
        @room-slot-not-available="openModalRoomSlotNotAvailable"/>

      <booking-room-slot-unavailable-modal
        ref="roomSlotUnavailable"
        :location="location"/>

      <div
        class="col px-0 calendarWeekGrid"
        :id="$id('mainCal')">
        <div :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
          <div class="bgDarker">
            <div class="row pt-4">
              <div class="col text-center">
                <h2 class="font-weight-bold calendarWeekGrid_Header_Title">
                  <template v-if="axeThrowing">
                    Available Axe Throwing At {{ location.name }}
                  </template>
                  <template v-else>
                    {{ roomsAvailable[date.format('YYYY-MM-DD')] && roomsAvailable[date.format('YYYY-MM-DD')].length ? roomsAvailable[date.format('YYYY-MM-DD')].length : '' }} Available Games for {{ $deploymentIs('breakescape') ? location.name.toUpperCase() : location.name }}
                  </template>
                </h2>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
              <div class="d-lg-none order-0 my-2">
                <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Month"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="previousMonthClicked">
                    <i class="material-icons">fast_rewind</i>
                    <p class="mb-0" style="font-size: 14px;">MONTH</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Week"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="previousWeekClicked">
                    <i class="material-icons">skip_previous</i>
                    <p class="mb-0" style="font-size: 14px;">WEEK</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Day"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="previousDayClicked">
                    <i class="material-icons" style="moz-transform: scaleX(-1); o-transform: scaleX(-1); -webkit-transform: scaleX(-1); transform: scaleX(-1); filter: FlipH; -ms-filter: 'FlipH'">play_arrow</i>
                    <p class="mb-0" style="font-size: 14px;">DAY</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Day"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="nextDayClicked">
                    <i class="material-icons">play_arrow</i>
                    <p class="mb-0" style="font-size: 14px;">DAY</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Week"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="nextWeekClicked">
                    <i class="material-icons">skip_next</i>
                    <p class="mb-0" style="font-size: 14px;">WEEK</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Month"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="nextMonthClicked">
                    <i class="material-icons">fast_forward</i>
                    <p class="mb-0" style="font-size: 14px;">MONTH</p>
                  </a>
                </div>
              </div>

              <div class="d-none d-lg-block my-2">
                <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Month"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="previousMonthClicked">
                    <i class="material-icons">fast_rewind</i>
                    <p class="mb-0">MONTH</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Week"
                    class="calendarWeekGrid_Button_PrevNext mx-4"
                    @click.prevent="previousWeekClicked">
                    <i class="material-icons">skip_previous</i>
                    <p class="mb-0">WEEK</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Previous Day"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="previousDayClicked">
                    <i class="material-icons" style="moz-transform: scaleX(-1); o-transform: scaleX(-1); -webkit-transform: scaleX(-1); transform: scaleX(-1); filter: FlipH; -ms-filter: 'FlipH'">play_arrow</i>
                    <p class="mb-0">DAY</p>
                  </a>
                </div>
              </div>

              <div class="py-2">
                <date-picker
                  ref="datePicker"
                  v-if="datePickerVisible"
                  :config="datePickerConfig"
                  v-model="datePicked"
                  @dp-change="datePickerChanged">
                </date-picker>

                <span
                  v-if="! datePickerVisible"
                  class="calendarWeekGrid_Button_PrevNext calendarGrid_Date_Title heading">
                  {{ date | moment('ddd, Do MMM YYYY') }}
                </span>
                <button
                  v-if="! datePickerVisible"
                  class="btn calendarGrid_Date_Btn"
                  @click="selectDate">
                  <span class="material-icons">date_range</span>
                </button>
              </div>

              <div class="d-none d-lg-block px-4 my-4">
                <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Day"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="nextDayClicked">
                    <i class="material-icons">play_arrow</i>
                    <p class="mb-0">DAY</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Week"
                    class="calendarWeekGrid_Button_PrevNext mx-4"
                    @click.prevent="nextWeekClicked">
                    <i class="material-icons">skip_next</i>
                    <p class="mb-0">WEEK</p>
                  </a>
                  <a
                    href="#"
                    rel="nofollow"
                    data-toggle="tooltip"
                    title="Next Month"
                    class="calendarWeekGrid_Button_PrevNext"
                    @click.prevent="nextMonthClicked">
                    <i class="material-icons">fast_forward</i>
                    <p class="mb-0">MONTH</p>
                  </a>
                </div>
              </div>
            </div>

            <table v-for="roomsGrouped in openRoomsGrouped" class="calendarWeekGrid_table">
              <thead>
                <tr
                  v-if="maximumSlotsInThisDay"
                  class="text-center">
                  <th
                    v-for="room in roomsGrouped"
                    :key="room.id"
                    :class="'pt-0 bg-' + room.nickname">
                    <mq-layout :mq="['xs', 'sm']" class="d-flex align-items-center justify-content-center">
                      <img :src="'/img/mp/room_icon_' + room.nickname + '.jpg'" style="width: 25px; border-radius: 50%; margin-right: 5px;">
                      <span :class="room.slug == 'abducted' || room.slug == 'bank-job' ? 'text-white' : ''">{{ room.short ? room.short : (room.slug.charAt(0).toUpperCase() + room.slug.slice(1)).replace(/-/g, '').substring(0,5) }}</span>
                    </mq-layout>
                    <mq-layout mq="md+" class="d-flex align-items-center justify-content-center" :class="room.room_address ? 'py-4' : 'py-2'">
                      <img :src="'/img/mp/room_icon_' + room.nickname + '.jpg'" style="width: 25px; border-radius: 50%; margin-right: 5px;">
                      <span :class="room.slug == 'abducted' || room.slug == 'bank-job' ? 'text-white' : ''">{{ room.name }}</span>
                    </mq-layout>
                    <div class="row mt-2 calendarWeekGrid_address" v-if="room.room_address">
                      <div class="col-sm-12 col-md-3 col-lg-2">
                        <div class="mb-0"><span class="material-icons">room</span></div>
                      </div>
                      <div class="col-sm-12 col-md-9 col-lg-10">
                        <div class="mb-0">{{ room.room_address }}</div>
                      </div>
                    </div>
                    <div class="row mt-2 calendarWeekGrid_address text-center" v-if="showDuration">
                      <div class="col">
                        <div class="mb-0"><span class="material-icons">lock_clock</span> {{ room.duration }}min</div>
                      </div>
                    </div>
                    <div class="row mt-2 calendarWeekGrid_address text-center" v-if="showPlayers">
                      <div class="col">
                        <div class="mb-0"><span class="material-icons">group</span> {{ room.play_min }}&mdash;{{ room.play_max }}</div>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr v-else>
                  <td :colspan="roomsGrouped.length">
                    <p>There are currently no RoomSlots set up for this time period. <span v-if="$deploymentIs('cryptology')" class="font-weight-bold"><br>Cryptology is closed on a Tuesday. With advanced notice we may be able to secure you a booking.</span></p>
                    <p v-if="$deploymentIs('horrorescape')">Please email the branch at <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a>
                    <p v-else-if="$deploymentIs('topescaperooms')"></p>
                    <p v-else>Please contact the branch on <a :href="'tel:' + location.telephone" class="text-white font-weight-bold">{{ location.telephone }}</a> or email <a :href="'mailto:' + location.email + '?subject=Enquiry about future availability'" class="text-white font-weight-bold">{{ location.email }}</a></p>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="roomSlotIndex in range(0, (maximumSlotsInThisDay - 1))">
                  <template v-for="room in roomsGrouped">
                    <td
                      v-if="roomSlotsForDate && roomSlotsForDate[room.id] && roomSlotsForDate[room.id][roomSlotIndex]"
                      :key="room.id"
                      :class="calendarCell(room.id, roomSlotIndex).class"
                      @click.prevent="roomSlotClicked(roomSlotsForDate[room.id][roomSlotIndex])">
                      <span class="calendarWeekGrid_Cell calendarWeekGrid_Cell_Time">
                        {{ roomSlotsForDate[room.id][roomSlotIndex].start | moment('h:mm') }}
                        <small>{{ roomSlotsForDate[room.id][roomSlotIndex].start | moment('a') }}</small>
                      </span>

                      <span class="calendarWeekGrid_Cell calendarWeekGrid_Cell_Availability" v-html="calendarCell(room.id, roomSlotIndex).text"></span>
                    </td>
                    <td v-else>
                      <span class="material-icons" :class="$deploymentIs('escapable') ? 'text-white' : ''">block</span>
                    </td>
                  </template>
                </tr>
              </tbody>
              <tfoot v-if="! $deploymentIs('horrorescape')">
                <tr class="text-center">
                  <td v-for="room in roomsGrouped">
                    <a
                      :href="locationRoomRoute(room.id, date.format('YYYY-MM-DD')) + '#book'"
                      :class="'btn btn-' + location.rooms.find(rm => rm.id == room.id).nickname">
                      {{ ($mq === 'sm' || $mq === 'xs') ? (location.rooms.find(rm => rm.id == room.id).short ? location.rooms.find(rm => rm.id == room.id).short : (location.rooms.find(rm => rm.id == room.id).slug.charAt(0).toUpperCase() + location.rooms.find(rm => rm.id == room.id).slug.slice(1)).replace(/-/g, '').substring(0,5)) : location.rooms.find(rm => rm.id == room.id).name }}
                    </a>
                  </td>
                </tr>
              </tfoot>
            </table>

            <!-- THE CART -->
            <booking-calendar-cart-summary
              v-model="cart"
              :location="location"></booking-calendar-cart-summary>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialCart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    currentRoomId: {
      type: Number,
      default: null,
    },
    initialDate: {
      type: String,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'A',
    },
    locationDiscount: {
      type: Object,
    },
    initialRoomSlots: {
      type: [Object, Array],
      // required: true,
    },
    initialRoomsAvailable: {
      type: [Object, Array],
      // required: true,
    },
    brand: {
      type: String,
    },
    maxPerRow: {
      type: Number,
      default: 5,
    },
    locationChildPricing: {
      type: Boolean,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    paymentProvider: {
      type: String,
      default: 'Testing',
    },
    axeThrowing: {
      type: Boolean,
      default: false,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    showPlayers: {
      type: Boolean,
      default: false,
    },
    bookingLabelAdults: {
      type: String,
      default: 'Adults',
    },
    bookingLabelAdultsSelection: {
      type: String,
      default: 'Select number of adults',
    },
    bookingChildCaveat: {
      type: String,
      default: 'Minimum of 2 adult tickets per game, regardless of age. A child is defined as 15 or younger.',
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
    bookingLabelStateLocked: {
      type: String,
      default: 'Reserved',
    },
    bookingLabelStateBooked: {
      type: String,
      default: 'Sold',
    },
  },

  data() {
    return {
      date: moment(this.initialDate),
      roomSlots: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialRoomSlots))),
      roomsAvailable: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialRoomsAvailable))),

      datePickerConfig: {
        format: 'YYYY-MM-DD',
        minDate: moment().startOf('day'),
        showTodayButton: true,
      },
      datePicked: moment(this.initialDate).format('YYYY-MM-DD'),
      datePickerVisible: false,

      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),
    };
  },

  computed: {
    /* ===============
     * timeslotCal computed
     */
    roomSlotsForDate() {
      let roomSlotsByRoom = [];

      if (this.roomSlots[this.date.format('YYYY-MM-DD')]) {
        this.location.rooms.forEach(room => {
          roomSlotsByRoom[room.id] = this.roomSlots[this.date.format('YYYY-MM-DD')].filter(rs => rs.room_id == room.id);
        });
      }

      return roomSlotsByRoom;
    },

    maximumSlotsInThisDay() {
      // how many rows we need to render
      let maxSlot = 0;

      if (this.roomSlotsForDate) {
        this.roomSlotsForDate.forEach(rs => maxSlot = Math.max(maxSlot, rs.length));
      }

      return maxSlot;
    },

    otherRoomsAvailableForDate() {
      if (this.currentRoomId && this.roomsAvailable[this.date.format('YYYY-MM-DD')]) {
        let roomIds = this.roomsAvailable[this.date.format('YYYY-MM-DD')]
            .filter(room_id => room_id != this.currentRoomId);

        if (roomIds === null) {
          return null;
        }

        return this.location.rooms
          .filter(room => roomIds.includes(room.id));
      }

      return null;
    },

    openRooms() {
      return this.location.rooms.filter(room => room.badge != 'SOON');
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    promoDate() {
      if (this.locationDiscount) {
        return moment(this.locationDiscount.date).format('YYYY-MM-DD');
      } else {
        return "N/A";
      }
    },

    openRoomsGrouped() {
      let roomGroup = [];
      this.openRooms.sort((a, b) => a.display_order - b.display_order);
      var rows = Math.ceil(this.openRooms.length / this.maxPerRow);
      var columns = Math.ceil(this.openRooms.length / rows);

      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < columns; c++) {
          if (((r*columns) + c) < this.openRooms.length) {
            roomGroup[r] = (typeof roomGroup[r] != 'undefined') ? roomGroup[r] : [];
            roomGroup[r].push(this.openRooms[(r*columns) + c]);
          }
        }
      }
      return roomGroup;
    },

    /*
     * END timeslotCal methods
     * =============== */

    roomSlotIdsInCart() {
      let roomSlotIds = [];

      if (this.cart) {
        this.cart.cart_items.forEach(cartItem => {
          if (cartItem.cartable_type == 'App\\Models\\RoomSlot') {
            roomSlotIds.push(cartItem.cartable_id);
          }
        });
      }

      return roomSlotIds;
    },

    deploymentBgClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'bg-cryptology-blue';
        case 'makeyourescape':
          return '';
        case 'coalville':
          return 'bg-lightest-gray';
        case 'escapestaging':
          return 'bg-escapestaging';
        case 'breakescape':
          return 'bg-breakescapebtn text-black';
        case 'levelup':
          return 'bg-levelup text-black';
        case 'taketheexit':
        case 'paralysis':
        case 'horrorescape':
        case 'escapegoat':
        case 'missionclassified':
        case 'rushden':
        case 'topescaperooms':
        case 'panicroomharlow':
        case 'escaporium':
        case 'axefactor':
        case 'escapetime':
        case 'operationescape':
        case 'oo7escaperooms':
        case 'theescapelounge':
        case 'lakesescapes':
        case 'funkysnake':
        case 'evadare':
        case 'mysteryquests':
        case 'xscapebangor':
        case 'ctrlaltesc':
        case 'mythologic':
        case 'enigmaescapecornwall':
          return 'bg-darkest-gray text-white';
        case 'cypherquest':
          return 'bg-cypherquest text-white';
        case 'kanyu':
        case 'beyondbreakout':
        case 'crypticescape':
        case 'escapereading':
          return 'bg-white text-black';
        case 'wisbech':
          return 'bg-wisbech text-white';
        case 'makeyourescape':
          return '';
        case 'the-real-escape':
          return 'bg-the-real-escape-bg text-white';
        case 'escapable':
          return 'bg-calendar-lighten-opacity text-white';
        case 'bridlington':
          return 'bg-bridlington-lighter text-white';
        case 'mansionofmystery':
          return 'bg-mansionofmysterypurple text-white';
        case 'trappedinfiction':
          return 'bg-trappedinfiction text-black';
        case 'cluehqsomerton':
          return 'bg-clue-hq-blue text-white';
        case 'blackout':
          return 'bg-blackout text-white';
        default:
          return 'bg-white text-black';
      }
    },
  },

  watch: {
    date: {
      handler(newDate, oldDate) {
        this.changeQueryString('dt', newDate.format('YYYY-MM-DD'));

        this.echoDeInit(oldDate);
        this.echoInit(newDate);
      },
      deep: true,
    },
  },

  methods: {
    /* ===============
     * mainCal methods
     */

    calendarCell(room_id, roomSlotIndex) {
      var theClass = '';
      var theText = '';
// roomSlotIdsInCart.includes(roomSlotsForDate[room.id][roomSlotIndex].id) ? 'inCart' :
//                         (! showCallToBookAsSold && roomSlotsForDate[room.id][roomSlotIndex].state == 'AVAILABLE' ? (checkCallToBook(roomSlotsForDate[room.id][roomSlotIndex]) ? 'calendarWeekGrid_bg_available_c2b' : 'calendarWeekGrid_bg_available') :
//                           (roomSlotsForDate[room.id][roomSlotIndex].state == 'LOCKED' || roomSlotsForDate[room.id][roomSlotIndex].state == 'BOOKED_PENDING' ? 'calendarWeekGrid_bg_locked' :
//                             (showCallToBookAsSold && roomSlotsForDate[room.id][roomSlotIndex].state == 'AVAILABLE' && ! checkCallToBook(roomSlotsForDate[room.id][roomSlotIndex]) ? 'calendarWeekGrid_bg_available' : 'calendarWeekGrid_bg_booked')))

      if (this.roomSlotIdsInCart.includes(this.roomSlotsForDate[room_id][roomSlotIndex].id)) {
        // if the slot is in the cart, this is what should be displayed
        theClass = 'inCart';
        theText = 'In Cart';
      } else if (this.roomSlotsForDate[room_id][roomSlotIndex].state == 'AVAILABLE') {
        // slot is available
        if (this.checkCallToBook(this.roomSlotsForDate[room_id][roomSlotIndex])) {
          if (this.showCallToBookAsSold) {
            theClass = 'calendarWeekGrid_bg_booked';
            theText = '&nbsp;' + this.bookingLabelStateBooked + '&nbsp;';
          } else {
            theClass = 'calendarWeekGrid_bg_available_c2b';
            theText = this.location.booking_options.c2b_calendar_title;
          }
        } else {
          theClass = 'calendarWeekGrid_bg_available';
          if (this.roomSlotsForDate[room_id][roomSlotIndex].public_booking) {
            theText = this.roomSlotsForDate[room_id][roomSlotIndex].availableRemainingTickets + '/' + (this.roomSlotsForDate[room_id][roomSlotIndex].override_play_max ? this.roomSlotsForDate[room_id][roomSlotIndex].override_play_max : this.location.rooms.find(r => r.id == room_id).play_max) + ' Available';
          } else {
            theText = 'Available';
          }
        }
      } else {
        if (this.roomSlotsForDate[room_id][roomSlotIndex].state == 'LOCKED' || this.roomSlotsForDate[room_id][roomSlotIndex].state == 'BOOKED_PENDING') {
          theClass = 'calendarWeekGrid_bg_locked';
          theText = this.bookingLabelStateLocked;
        } else if (this.roomSlotsForDate[room_id][roomSlotIndex].state == 'BOOKED_PART') {
          theClass = 'calendarWeekGrid_bg_available_part';
          theText = this.roomSlotsForDate[room_id][roomSlotIndex].availableRemainingTickets + '/' + (this.roomSlotsForDate[room_id][roomSlotIndex].override_play_max ? this.roomSlotsForDate[room_id][roomSlotIndex].override_play_max : this.location.rooms.find(r => r.id == room_id).play_max) + ' Available';
        } else {
          theClass = 'calendarWeekGrid_bg_booked';
          theText = this.bookingLabelStateBooked;
        }
      }
      return {
        class: theClass,
        text: theText,
      };
    },

    isMonthDaySelectable(dayInMonth) {
      let theDate = this.date.clone().date(dayInMonth);

      if (theDate < moment().date()
        || ! ([theDate.format('YYYY-MM-DD')] in this.roomSlots)
        || ([theDate.format('YYYY-MM-DD')] in this.roomSlots && (! ([theDate.format('YYYY-MM-DD')] in this.roomsAvailable)))
      ) {
        return false; // want a span, not a button
      }

      return true; // get a button, not a span
    },

    selectDayInMonth(dayInMonth) {
      this.date = this.date.clone().date(dayInMonth);
    },

    isMonthDayFullyBooked(dayInMonth) {
      // there are bookings, and none are available
      let theDate = this.date.clone().date(dayInMonth);

      if (theDate < moment().date()) {
        return false;
      }

      if (! ([theDate.format('YYYY-MM-DD')] in this.roomSlots)) {
        return false;
      }

      return ! ([theDate.format('YYYY-MM-DD')] in this.roomsAvailable);
    },

    isMonthDayFullyBookedandCryptology(dayInMonth) {
      if (this.$deploymentIs('cryptology')) {
        return this.isMonthDayFullyBooked(dayInMonth);
      }

      return false;
    },

    nextMonthClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().add(1, 'month');
      this.fetchRoomSlots(newDate);
    },

    previousMonthClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'month');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      if (this.date.isSame(newDate, 'week')) {
        this.date = newDate;

        return;
      }

      this.fetchRoomSlots(newDate);
    },

    nextWeekClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().add(1, 'week');

      if (this.date.isSame(newDate, 'week')) {
        this.date = newDate;

        return;
      }

      this.fetchRoomSlots(newDate);
    },

    previousWeekClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'week');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      if (this.date.isSame(newDate, 'week')) {
        this.date = newDate;

        return;
      }

      this.fetchRoomSlots(newDate);
    },

    previousDayClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'day');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      if (this.date.isSame(newDate, 'week')) {
        this.date = newDate;

        return;
      }

      this.fetchRoomSlots(newDate);
    },

    nextDayClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().add(1, 'day');

      if (this.date.isSame(newDate, 'week')) {
        this.date = newDate;

        return;
      }

      this.fetchRoomSlots(newDate);
    },

    selectDate() {
      this.datePickerVisible = true;
      this.$nextTick(() => {
        this.$refs.datePicker.dp.show();
      });
    },

    datePickerChanged() {
      let datePicked = moment(this.datePicked);

      if (this.date.isSame(datePicked)) {
        return;
      }

      this.datePickerVisible = false;

      if (this.date.isSame(datePicked, 'week')) {
        this.date = datePicked;

        return;
      }

      this.fetchRoomSlots(datePicked);
    },

    refetchRoomSlots() {
      this.fetchRoomSlots(this.date);
    },

    fetchRoomSlots(newDate) {
      let roomSlotsRequest = {
        for_rooms_for_week: 1,
        room_ids: this.location.rooms.map(room => room.id),
        date: newDate.toISOString(true),
      };

      let roomsAvailableRequest = {
        ...roomSlotsRequest,
        availability_only: 1,
      };

      this.loading(true, this.$refs.calendarContainer);

      Promise.all([
        axios.get(this.route('api.room-slots.index'), {params: roomSlotsRequest}),
        axios.get(this.route('api.room-slots.index'), {params: roomsAvailableRequest})
      ])
        .then(results => {
          const roomSlotsResponse = results[0];
          const roomsAvailableResponse = results[1];

          if (roomSlotsResponse.status == 200 && roomsAvailableResponse.status == 200) {
            this.roomSlots = roomSlotsResponse.data;
            this.roomsAvailable = roomsAvailableResponse.data;
            this.date = newDate;
          } else {
            flash('Error fetching data.', 'danger');
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.data);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.status);
            console.log('fetchRoomSlots:roomSlotsResponse', roomSlotsResponse.statusText);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.data);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.status);
            console.log('fetchRoomSlots:roomsAvailableResponse', roomsAvailableResponse.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error fetching room slots', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('fetchRoomSlots:401', error.response.data);
              window.location.reload();
            }
            console.log('fetchRoomSlots: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('fetchRoomSlots: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('fetchRoomSlots: Error', error.message);
          }

          this.loading(false);
        });
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      url.searchParams.set(param, value);
      let state = {[param]: value};
      history.pushState(state, '', url);
    },

    /*
     * END mainCal methods
     * =============== */

    /* ===============
     * timeslotCal methods
     */

    slotClickable(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'AVAILABLE':
        case 'BOOKED_PENDING':
        case 'BOOKED_PART':
          return true;
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
        default:
          return false;
      }
    },

    slotStateClass(roomSlot) {
      switch (roomSlot.state) {
        case 'LOCKED':
        case 'BOOKED_PENDING':
          return 'timeSlotCalLocked';
        case 'BOOKED':
        case 'HIDDEN':
        case 'UNSOLD':
        case 'DELETED':
          return 'timeSlotCalBooked';
        case 'AVAILABLE':
        case 'BOOKED_PART':
          return 'timeSlotCalNotBookedCal';
        default:
          return '';
      }
    },

    slotStateStringForDisplay(roomSlot) {
      switch (roomSlot.state) {
        case 'HIDDEN':
        case 'UNSOLD':
          return 'Booked'
        default:
          return roomSlot.state_string;
      }
    },

    roomFor(roomSlot) {
      return this.location.rooms.find(room => room.id == roomSlot.room_id);
    },

    roomSlotClicked(roomSlot) {
      // console.log('roomSlotClicked', roomSlot);
      let bookingMinutes = this.location.booking_minutes;
      // console.log('moment less minutes', moment(roomSlot.start).subtract(bookingMinutes, 'minutes').format("dddd, MMMM Do YYYY, h:mm:ss a"));

      if (this.checkCallToBook(roomSlot)) {
        // console.log('show callForBooking Modal');
        if (this.showCallToBookAsSold) {
          // do nothing
        } else {
         this.$refs.callForBooking.showModal();
        }
      } else {
        this.$refs.makeBooking.startBooking(roomSlot);
      }
    },

    checkCallToBook(roomSlot) {
      return moment(roomSlot.start).subtract(this.location.booking_minutes, 'minutes') < moment() || roomSlot.call_to_book != 'NO';
    },

    openModalRoomSlotNotAvailable() {
      // console.log('openModalRoomSlotNotAvailable()');
      this.$refs.makeBooking.hideAllModals();
      this.$refs.roomSlotUnavailable.showModal();
    },

    /*
     * END timeslotCal methods
     * =============== */

    /* ===============
     * Echo methods
     */
    echoInit(date) {
      // console.log('echoInit(date)', date);
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('booking-calendar.room-slots.' + date.format('YYYY-MM'))
        .listen('BookingCalendar.RoomSlotChanged', this.roomSlotChangedEvent)
        .listen('BookingCalendar.RoomSlotDeleted', this.roomSlotDeletedEvent);
    },

    echoDeInit(date) {
      // console.log('echoDeInit(date)', date);
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('room-slots.' + date.format('YYYY-MM'));
    },

    roomSlotChangedEvent(event) {
      // console.log('roomSlotChangedEvent(event)', event);
      let roomSlotDate = moment(event.roomSlot.start).format('YYYY-MM-DD');
      if (! this.roomSlots.hasOwnProperty(roomSlotDate)) {
        return;
      }

      let roomSlotIndex = this.roomSlots[roomSlotDate].findIndex(rs => rs.id == event.roomSlot.id);
      if (roomSlotIndex == -1) {
        return;
      }

      this.$set(this.roomSlots[roomSlotDate], roomSlotIndex, event.roomSlot);
    },

    roomSlotDeletedEvent(event) {
      // console.log('roomSlotDeletedEvent(event)', event);
      let roomSlotDate = moment(event.roomSlot.start).format('YYYY-MM-DD');
      if (! this.roomSlots.hasOwnProperty(roomSlotDate)) {
        return;
      }

      let roomSlotIndex = this.roomSlots[roomSlotDate].findIndex(rs => rs.id == event.roomSlot.id);
      if (roomSlotIndex == -1) {
        return;
      }

      this.$delete(this.roomSlots[roomSlotDate], roomSlotIndex);
    },

    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      Echo.channel('booking-calendar.cart.session.' + this.cart.session)
        .listen('BookingCalendar.VirtualRoomSlotAvailabilityForCart', this.virtualRoomSlotAvailabilityForCartEvent);
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
      Echo.leave('booking-calendar.cart.session.' + this.cart.session)
    },

    cartSavedEvent(event) {
      console.log('cartSavedEvent(event)', event);
      this.cart = event.cart;
    },

    virtualRoomSlotAvailabilityForCartEvent(event) {
      // console.log('virtualRoomSlotAvailabilityForCartEvent(event) @ ' + moment().format('HH:mm'), event);
      if (this.roomSlots[event.date]) {
        this.$set(this.roomSlots, event.date, event.roomSlots);
      }
    },

    locationRoomRoute(room_id, date) {
      let room = this.location.rooms.find(room => room.id == room_id);

      return this.route(this.location.locationRoomRoute, {location: this.location.slug, room: room.slug, dt: date});
    },

    /*
     * END Echo methods
     * =============== */

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
  },

  mounted() {
    this.echoInit(this.date);

    this.$nextTick(() => {
      this.echoInitCart();
    });

  },

  beforeDestroy() {
    this.echoDeInit(this.date);
    this.echoDeInitCart();
  },
}
</script>
